"use strict"; // Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

exports.__esModule = true;
exports.isContextExperience = exports.getContextExperienceIdentifier = void 0;

var enums_1 = require("../../enums");

var isContextExperience = function isContextExperience(experience) {
  return !!experience && experience.experienceType === enums_1.ExperienceType.CONTEXT;
};

exports.isContextExperience = isContextExperience;

var getContextExperienceIdentifier = function getContextExperienceIdentifier(experience) {
  if (!isContextExperience(experience)) {
    return;
  }

  var contextId = experience.contextId,
      experienceType = experience.experienceType,
      discriminator = experience.discriminator;
  return [contextId, experienceType, discriminator].filter(Boolean).join('-');
};

exports.getContextExperienceIdentifier = getContextExperienceIdentifier;